// src/entities/commercial/contact.entity.ts
var ContactRoleEnum = /* @__PURE__ */ ((ContactRoleEnum2) => {
  ContactRoleEnum2["analyst"] = "analyst";
  ContactRoleEnum2["supervisor"] = "supervisor";
  ContactRoleEnum2["manager"] = "manager";
  ContactRoleEnum2["director"] = "director";
  ContactRoleEnum2["president"] = "president";
  ContactRoleEnum2["owner"] = "owner";
  ContactRoleEnum2["other"] = "other";
  return ContactRoleEnum2;
})(ContactRoleEnum || {});
var ContactDepartmentEnum = /* @__PURE__ */ ((ContactDepartmentEnum2) => {
  ContactDepartmentEnum2["administrative"] = "administrative";
  ContactDepartmentEnum2["commercial"] = "commercial";
  ContactDepartmentEnum2["purchasing"] = "purchasing";
  ContactDepartmentEnum2["financial"] = "financial";
  ContactDepartmentEnum2["logistics"] = "logistics";
  ContactDepartmentEnum2["operations"] = "operations";
  ContactDepartmentEnum2["presidency"] = "presidency";
  ContactDepartmentEnum2["product"] = "product";
  ContactDepartmentEnum2["owner"] = "owner";
  ContactDepartmentEnum2["support"] = "support";
  ContactDepartmentEnum2["other"] = "other";
  return ContactDepartmentEnum2;
})(ContactDepartmentEnum || {});

// src/entities/commercial/financial-payment.entity.ts
var FinancialObligationMethod = { PIX: "PIX", BOLETO: "BOLETO" };
var FinancialObligationStatus = {
  PENDING_PAYMENT: "PENDING_PAYMENT",
  PENDING_VALIDATION: "PENDING_VALIDATION",
  APPROVED: "APPROVED",
  CANCELED: "CANCELED",
  INTEGRATION_RETRY: "INTEGRATION_RETRY"
};
var OmieBillingSlipIntegrationState = {
  NOT_STARTED: "NOT_STARTED",
  RECEIVABLE_UNKNOWN: "RECEIVABLE_UNKNOWN",
  RECEIVABLE_CREATED: "RECEIVABLE_CREATED",
  BILLING_SLIP_UNKNOWN: "BILLING_SLIP_UNKNOWN",
  BILLING_SLIP_GENERATED: "BILLING_SLIP_GENERATED",
  RETRY_REQUIRED: "RETRY_REQUIRED",
  CANCEL_REQUESTED: "CANCEL_REQUESTED",
  CANCELED: "CANCELED",
  INCONSISTENT: "INCONSISTENT"
};

// src/entities/commercial/product.entity.ts
var OmieEnterpriseEnum = /* @__PURE__ */ ((OmieEnterpriseEnum2) => {
  OmieEnterpriseEnum2["BWS"] = "BWS";
  OmieEnterpriseEnum2["BSTOCK"] = "BSTOCK";
  return OmieEnterpriseEnum2;
})(OmieEnterpriseEnum || {});

// src/entities/commercial/proposal.entity.ts
var ProposalStatus = /* @__PURE__ */ ((ProposalStatus2) => {
  ProposalStatus2["OPEN"] = "OPEN";
  ProposalStatus2["FINISHED"] = "FINISHED";
  ProposalStatus2["CANCELED"] = "CANCELED";
  ProposalStatus2["PENDING_CREDIT"] = "PENDING_CREDIT";
  ProposalStatus2["PENDING_ACCEPT"] = "PENDING_ACCEPT";
  ProposalStatus2["ACCEPTED_PENDING_PAYMENT"] = "ACCEPTED_PENDING_PAYMENT";
  ProposalStatus2["REFUSED"] = "REFUSED";
  ProposalStatus2["EXPIRED"] = "EXPIRED";
  return ProposalStatus2;
})(ProposalStatus || {});

// src/entities/admin/audit.entity.ts
var AuditType = /* @__PURE__ */ ((AuditType2) => {
  AuditType2["create"] = "create";
  AuditType2["update"] = "update";
  return AuditType2;
})(AuditType || {});
var AuditDomain = /* @__PURE__ */ ((AuditDomain2) => {
  AuditDomain2["user"] = "user";
  AuditDomain2["profile"] = "profile";
  AuditDomain2["account"] = "account";
  AuditDomain2["accountAddress"] = "accountAddress";
  AuditDomain2["accountContact"] = "accountContact";
  AuditDomain2["accountAttachments"] = "accountAttachments";
  AuditDomain2["priceTable"] = "priceTable";
  AuditDomain2["externalLink"] = "externalLink";
  AuditDomain2["creditAnalysis"] = "creditAnalysis";
  AuditDomain2["accountDocuments"] = "accountDocuments";
  return AuditDomain2;
})(AuditDomain || {});

// src/entities/production/device.entity.ts
var Device;
((Device2) => {
  let Model;
  ((Model2) => {
    Model2["DM_E3_PLUS"] = "DM_E3_PLUS";
    Model2["DM_E3_PLUS_PERSONAL"] = "DM_E3_PLUS_PERSONAL";
    Model2["DM_E3_PLUS_PET"] = "DM_E3_PLUS_PET";
    Model2["DM_E3_PLUS_OBD_II"] = "DM_E3_PLUS_OBD_II";
    Model2["DM_E3_PLUS_LONG_LIFE"] = "DM_E3_PLUS_LONG_LIFE";
    Model2["DM_E3"] = "DM_E3";
    Model2["DM_GT06"] = "DM_GT06";
    Model2["DM_E3_PLUS_4G"] = "DM_E3_PLUS_4G";
    Model2["DM_BWS_PLUS_4G_LORA"] = "DM_BWS_PLUS_4G_LORA";
    Model2["DM_BWS_NB2"] = "DM_BWS_NB2";
    Model2["DM_BWS_NB2_LORA"] = "DM_BWS_NB2_LORA";
    Model2["DM_BWS_LORA"] = "DM_BWS_LORA";
    Model2["DM_BWS_4G"] = "DM_BWS_4G";
    Model2["DM_BWS_BUSCADOR"] = "DM_BWS_BUSCADOR";
    Model2["DM_BWS_LL_NB"] = "DM_BWS_LL_NB";
    Model2["DM_BWS_LL_NB_LORA"] = "DM_BWS_LL_NB_LORA";
    Model2["DM_BWS_BAIT_NB"] = "DM_BWS_BAIT_NB";
    Model2["DM_BWS_BAIT_NB_LORA"] = "DM_BWS_BAIT_NB_LORA";
    Model2["UNRECOGNIZED"] = "UNRECOGNIZED";
  })(Model = Device2.Model || (Device2.Model = {}));
})(Device || (Device = {}));

// src/entities/production/configuration-profile.entity.ts
var ConfigurationProfileType = /* @__PURE__ */ ((ConfigurationProfileType2) => {
  ConfigurationProfileType2["HUMAN"] = "HUMAN";
  ConfigurationProfileType2["TRUCK"] = "TRUCK";
  ConfigurationProfileType2["MOTORCYCLE"] = "MOTORCYCLE";
  ConfigurationProfileType2["STUFF"] = "STUFF";
  ConfigurationProfileType2["BOAT"] = "BOAT";
  ConfigurationProfileType2["CAR"] = "CAR";
  ConfigurationProfileType2["BUS"] = "BUS";
  ConfigurationProfileType2["UTILITY_VEHICLE"] = "UTILITY_VEHICLE";
  ConfigurationProfileType2["BIKE"] = "BIKE";
  ConfigurationProfileType2["ANIMAL"] = "ANIMAL";
  ConfigurationProfileType2["ROAD_IMPLEMENT"] = "ROAD_IMPLEMENT";
  ConfigurationProfileType2["FARM_IMPLEMENT"] = "FARM_IMPLEMENT";
  ConfigurationProfileType2["JET"] = "JET";
  ConfigurationProfileType2["JET_SKI"] = "JET_SKI";
  ConfigurationProfileType2["AIRCRAFT"] = "AIRCRAFT";
  ConfigurationProfileType2["OTHER"] = "OTHER";
  return ConfigurationProfileType2;
})(ConfigurationProfileType || {});

// src/entities/connectivity/job.entity.ts
var JobStatus = /* @__PURE__ */ ((JobStatus2) => {
  JobStatus2["JS_PENDING"] = "PENDING";
  JobStatus2["JS_PROCESSING"] = "PROCESSING";
  JobStatus2["JS_SUCCESS"] = "SUCCESS";
  JobStatus2["JS_FAILED"] = "FAILED";
  return JobStatus2;
})(JobStatus || {});

// src/enums/brazilian-uf.enum.ts
var BRAZILIAN_UF_VALUES = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO"
];
var BRAZILIAN_UF_LIST = [
  { id: "AC", text: "Acre" },
  { id: "AL", text: "Alagoas" },
  { id: "AP", text: "Amap\xE1" },
  { id: "AM", text: "Amazonas" },
  { id: "BA", text: "Bahia" },
  { id: "CE", text: "Cear\xE1" },
  { id: "DF", text: "Distrito Federal" },
  { id: "ES", text: "Esp\xEDrito Santo" },
  { id: "GO", text: "Goi\xE1s" },
  { id: "MA", text: "Maranh\xE3o" },
  { id: "MT", text: "Mato Grosso" },
  { id: "MS", text: "Mato Grosso do Sul" },
  { id: "MG", text: "Minas Gerais" },
  { id: "PA", text: "Par\xE1" },
  { id: "PB", text: "Para\xEDba" },
  { id: "PR", text: "Paran\xE1" },
  { id: "PE", text: "Pernambuco" },
  { id: "PI", text: "Piau\xED" },
  { id: "RJ", text: "Rio de Janeiro" },
  { id: "RN", text: "Rio Grande do Norte" },
  { id: "RS", text: "Rio Grande do Sul" },
  { id: "RO", text: "Rond\xF4nia" },
  { id: "RR", text: "Roraima" },
  { id: "SC", text: "Santa Catarina" },
  { id: "SP", text: "S\xE3o Paulo" },
  { id: "SE", text: "Sergipe" },
  { id: "TO", text: "Tocantins" }
];
var BRAZILIAN_UF_NAMES = {
  AC: "Acre",
  AL: "Alagoas",
  AP: "Amap\xE1",
  AM: "Amazonas",
  BA: "Bahia",
  CE: "Cear\xE1",
  DF: "Distrito Federal",
  ES: "Esp\xEDrito Santo",
  GO: "Goi\xE1s",
  MA: "Maranh\xE3o",
  MT: "Mato Grosso",
  MS: "Mato Grosso do Sul",
  MG: "Minas Gerais",
  PA: "Par\xE1",
  PB: "Para\xEDba",
  PR: "Paran\xE1",
  PE: "Pernambuco",
  PI: "Piau\xED",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RS: "Rio Grande do Sul",
  RO: "Rond\xF4nia",
  RR: "Roraima",
  SC: "Santa Catarina",
  SP: "S\xE3o Paulo",
  SE: "Sergipe",
  TO: "Tocantins"
};

// src/enums/price-table-status.enum.ts
var PriceTableStatus = /* @__PURE__ */ ((PriceTableStatus2) => {
  PriceTableStatus2["ACTIVE"] = "ACTIVE";
  PriceTableStatus2["INACTIVE"] = "INACTIVE";
  PriceTableStatus2["CANCELLED"] = "CANCELLED";
  PriceTableStatus2["AWAITING_PUBLICATION"] = "AWAITING_PUBLICATION";
  PriceTableStatus2["DRAFT"] = "DRAFT";
  PriceTableStatus2["PAUSED"] = "PAUSED";
  return PriceTableStatus2;
})(PriceTableStatus || {});
var PRICE_TABLE_STATUS_LABELS = {
  ["ACTIVE" /* ACTIVE */]: "Ativa",
  ["INACTIVE" /* INACTIVE */]: "Inativa",
  ["CANCELLED" /* CANCELLED */]: "Cancelada",
  ["AWAITING_PUBLICATION" /* AWAITING_PUBLICATION */]: "Aguardando Publica\xE7\xE3o",
  ["DRAFT" /* DRAFT */]: "Rascunho",
  ["PAUSED" /* PAUSED */]: "Pausada"
};

// src/constants/admin/control-codes.constants.ts
var ControlCodes = {
  // ── Admin ───────────────────────────────────────────────────────────────
  admin: "admin",
  admin_user: "admin:user",
  admin_user_view: "admin:user:view",
  admin_user_create: "admin:user:create",
  admin_user_update: "admin:user:update",
  admin_profile: "admin:profile",
  admin_profile_view: "admin:profile:view",
  admin_profile_create: "admin:profile:create",
  admin_profile_inactive: "admin:profile:inactive",
  admin_control: "admin:control",
  admin_control_view: "admin:control:view",
  admin_control_update: "admin:control:update",
  // ── Production ──────────────────────────────────────────────────────────
  production: "production",
  production_device: "production:device",
  production_device_view: "production:device:view",
  production_configuration_profile: "production:configuration-profile",
  production_configuration_profile_view: "production:configuration-profile:view",
  production_tool: "production:tool",
  production_tool_configurator: "production:tool:configurator",
  production_tool_configurator_view: "production:tool:configurator:view",
  production_tool_auto_test: "production:tool:auto-test",
  production_tool_auto_test_view: "production:tool:auto-test:view",
  production_tool_configuration_check: "production:tool:configuration-check",
  production_tool_configuration_check_view: "production:tool:configuration-check:view",
  production_tool_firmware_recording: "production:tool:firmware-recording",
  production_tool_firmware_recording_view: "production:tool:firmware-recording:view",
  production_tool_identifier: "production:tool:identifier",
  production_tool_identifier_view: "production:tool:identifier:view",
  production_tool_serial_terminal: "production:tool:serial-terminal",
  production_tool_serial_terminal_view: "production:tool:serial-terminal:view",
  production_shared_data: "production:shared-data",
  production_logs: "production:logs",
  production_logs_configurator: "production:logs:configurator",
  production_logs_configurator_view: "production:logs:configurator:view",
  production_logs_auto_test: "production:logs:auto-test",
  production_logs_auto_test_view: "production:logs:auto-test:view",
  production_logs_firmware_recording: "production:logs:firmware-recording",
  production_logs_firmware_recording_view: "production:logs:firmware-recording:view",
  production_logs_identifier: "production:logs:identifier",
  production_logs_identifier_view: "production:logs:identifier:view",
  // ── Commercial ──────────────────────────────────────────────────────────
  commercial: "commercial",
  commercial_salesperson: "commercial:salesperson",
  commercial_salesperson_view: "commercial:salesperson:view",
  commercial_salesperson_update: "commercial:salesperson:update",
  commercial_client: "commercial:client",
  commercial_proposal: "commercial:proposal",
  commercial_proposal_view: "commercial:proposal:view",
  commercial_proposal_create: "commercial:proposal:create",
  commercial_proposal_payment_config: "commercial:proposal:payment-config",
  commercial_proposal_update: "commercial:proposal:update",
  commercial_proposal_update_specific_price_create: "commercial:proposal:update:specific-price:create",
  commercial_proposal_update_specific_price_update: "commercial:proposal:update:specific-price:update",
  commercial_proposal_update_specific_price_delete: "commercial:proposal:update:specific-price:delete",
  commercial_proposal_update_seller: "commercial:proposal:update:seller",
  commercial_accounts: "commercial:accounts",
  commercial_accounts_view: "commercial:accounts:view",
  commercial_accounts_view_lgpd_full: "commercial:accounts:view:lgpd:full",
  commercial_accounts_view_lgpd_partial: "commercial:accounts:view:lgpd:partial",
  commercial_accounts_access: "commercial:accounts:access",
  commercial_accounts_access_lgpd_full: "commercial:accounts:access:lgpd:full",
  commercial_accounts_access_lgpd_partial: "commercial:accounts:access:lgpd:partial",
  commercial_accounts_access_tab_data: "commercial:accounts:access:tab:data",
  commercial_accounts_access_tab_data_edit: "commercial:accounts:access:tab:data:edit",
  commercial_accounts_access_tab_data_group_edit: "commercial:accounts:access:tab:data:group-edit",
  commercial_accounts_access_tab_data_contacts: "commercial:accounts:access:tab:data:contacts",
  commercial_accounts_access_tab_data_addresses: "commercial:accounts:access:tab:data:addresses",
  commercial_accounts_access_tab_history: "commercial:accounts:access:tab:history",
  commercial_accounts_access_tab_attachments: "commercial:accounts:access:tab:attachments",
  commercial_accounts_access_tab_attachments_delete: "commercial:accounts:access:tab:attachments:delete",
  commercial_accounts_new: "commercial:accounts:new",
  commercial_accounts_new_sector: "commercial:accounts:new:sector",
  commercial_accounts_group_admin: "commercial:accounts:group-admin",
  commercial_price_table: "commercial:price-table",
  commercial_price_table_view: "commercial:price-table:view",
  commercial_price_table_create: "commercial:price-table:create",
  commercial_price_table_edit: "commercial:price-table:edit",
  commercial_price_table_edit_save: "commercial:price-table:edit:save",
  commercial_price_table_edit_cancel: "commercial:price-table:edit:cancel",
  commercial_price_table_edit_inactivate: "commercial:price-table:edit:inactivate",
  commercial_price_table_edit_publish: "commercial:price-table:edit:publish",
  commercial_price_table_clone: "commercial:price-table:clone",
  commercial_price_table_pix_key: "commercial:price-table:pix-key",
  commercial_credit_analysis: "commercial:credit-analysis",
  commercial_credit_analysis_view: "commercial:credit-analysis:view",
  commercial_product: "commercial:product",
  commercial_product_view: "commercial:product:view",
  commercial_product_category: "commercial:product:category",
  commercial_product_category_create: "commercial:product:category:create",
  commercial_product_transaction: "commercial:product:transaction",
  commercial_product_stock: "commercial:product:stock",
  commercial_product_analysis: "commercial:product:analysis",
  commercial_product_create: "commercial:product:create",
  // ── Connectivity ────────────────────────────────────────────────────────
  connectivity: "connectivity",
  connectivity_kora_sync: "connectivity:kora-sync",
  connectivity_kora_sync_view: "connectivity:kora-sync:view",
  connectivity_lora_activation: "connectivity:lora-activation",
  connectivity_lora_activation_bulk_actions: "connectivity:lora-activation:bulk-actions",
  connectivity_lora_activation_bulk_actions_view: "connectivity:lora-activation:bulk-actions:view",
  connectivity_lora_activation_logs: "connectivity:lora-activation:logs",
  connectivity_lora_activation_logs_view: "connectivity:lora-activation:logs:view",
  // ── Financial ─────────────────────────────────────────────────────────────────────────
  financial: "financial",
  financial_payment_confirmation: "financial:payment-confirmation",
  financial_payment_confirmation_view: "financial:payment-confirmation:view",
  financial_payment_confirmation_approve: "financial:payment-confirmation:approve"
};

// src/constants/commercial/price-table.constants.ts
var TO_BILL_FOR_OPTIONS = [
  { id: "20.618.574/0002-16", text: "BWS - 20.618.574/0002-16" },
  { id: "41.459.104/0001-46", text: "HYBRID - 41.459.104/0001-46 (MATRIZ)" },
  { id: "41.459.104/0002-27", text: "HYBRID - 41.459.104/0002-27 (FILIAL MG)" },
  { id: "34.984.723/0001-94", text: "ICB - 34.984.723/0001-94 (MATRIZ)" },
  { id: "34.984.723/0002-75", text: "ICB - 34.984.723/0002-75 (FILIAL SP)" },
  { id: "34.984.723/0003-56", text: "ICB 34.984.723/0003-56 (FILIAL MG)" },
  { id: "31.941.680/0001-71", text: "MGC - 31.941.680/0001-71" },
  {
    id: "41.738.608/0001-03",
    text: "PRMA FEDERAL - PRONTA RESPOSTA, MONITORAMENTO - 41.738.608/0001-03"
  },
  { id: "14.334.132/0001-64", text: "WFC - 14.334.132/0001-64" }
];

// src/constants/commercial/account.constants.ts
var ClientSectorEnum = /* @__PURE__ */ ((ClientSectorEnum2) => {
  ClientSectorEnum2["vehicle_protection_association"] = "vehicle_protection_association";
  ClientSectorEnum2["retail_trade"] = "retail_trade";
  ClientSectorEnum2["tracking_company"] = "tracking_company";
  ClientSectorEnum2["service_company"] = "service_company";
  ClientSectorEnum2["vehicle_protection_manager"] = "vehicle_protection_manager";
  ClientSectorEnum2["industry"] = "industry";
  ClientSectorEnum2["integrator_ti"] = "integrator_ti";
  ClientSectorEnum2["rental_company"] = "rental_company";
  ClientSectorEnum2["logistics"] = "logistics";
  ClientSectorEnum2["iot_tracking_platform"] = "iot_tracking_platform";
  ClientSectorEnum2["resale"] = "resale";
  ClientSectorEnum2["insurance_company"] = "insurance_company";
  ClientSectorEnum2["patrimonial_security"] = "patrimonial_security";
  ClientSectorEnum2["carrier"] = "carrier";
  ClientSectorEnum2["other"] = "other";
  return ClientSectorEnum2;
})(ClientSectorEnum || {});
var TaxRegime = /* @__PURE__ */ ((TaxRegime2) => {
  TaxRegime2["SIMPLES_NACIONAL"] = "SIMPLES_NACIONAL";
  TaxRegime2["LUCRO_PRESUMIDO"] = "LUCRO_PRESUMIDO";
  TaxRegime2["LUCRO_REAL"] = "LUCRO_REAL";
  TaxRegime2["MEI"] = "MEI";
  TaxRegime2["ISENTO"] = "ISENTO";
  TaxRegime2["PRODUTOR_RURAL"] = "PRODUTOR_RURAL";
  TaxRegime2["OUTRO"] = "OUTRO";
  return TaxRegime2;
})(TaxRegime || {});
var CLIENT_SECTOR_LABELS = {
  ["vehicle_protection_association" /* vehicle_protection_association */]: "Associa\xE7\xE3o de Prote\xE7\xE3o Veicular",
  ["retail_trade" /* retail_trade */]: "Com\xE9rcio Varejista",
  ["tracking_company" /* tracking_company */]: "Empresa de Rastreamento",
  ["service_company" /* service_company */]: "Empresa de Servi\xE7os",
  ["vehicle_protection_manager" /* vehicle_protection_manager */]: "Gestor de Prote\xE7\xE3o Veicular",
  ["industry" /* industry */]: "Ind\xFAstria",
  ["integrator_ti" /* integrator_ti */]: "Integrador TI",
  ["rental_company" /* rental_company */]: "Locadora",
  ["logistics" /* logistics */]: "Log\xEDstica",
  ["iot_tracking_platform" /* iot_tracking_platform */]: "Plataforma IoT/Rastreamento",
  ["resale" /* resale */]: "Revenda",
  ["insurance_company" /* insurance_company */]: "Seguradora",
  ["patrimonial_security" /* patrimonial_security */]: "Seguran\xE7a Patrimonial",
  ["carrier" /* carrier */]: "Transportadora",
  ["other" /* other */]: "Outro"
};
var TAX_REGIME_LABELS = {
  ["SIMPLES_NACIONAL" /* SIMPLES_NACIONAL */]: "Simples Nacional",
  ["LUCRO_PRESUMIDO" /* LUCRO_PRESUMIDO */]: "Lucro Presumido",
  ["LUCRO_REAL" /* LUCRO_REAL */]: "Lucro Real",
  ["MEI" /* MEI */]: "MEI",
  ["ISENTO" /* ISENTO */]: "Isento",
  ["PRODUTOR_RURAL" /* PRODUTOR_RURAL */]: "Produtor Rural",
  ["OUTRO" /* OUTRO */]: "Outro"
};
var BILLING_STATUS_OPTIONS = ["Ativo", "Inativo"];
var BILLING_SITUATION_OPTIONS = [
  "Adimplente",
  "Inadimplente",
  "Inadimplente/Bloqueado"
];
var ACCOUNT_TYPE_OPTIONS = ["MEI", "ME", "EPP", "DEMAIS", "PF"];
var ACCOUNT_TYPE_LABELS = {
  MEI: "MEI",
  ME: "ME",
  EPP: "EPP",
  DEMAIS: "Demais",
  PF: "Pessoa F\xEDsica"
};

// src/constants/commercial/product-category.constants.ts
var SystemCategoryCode = /* @__PURE__ */ ((SystemCategoryCode2) => {
  SystemCategoryCode2["BWS_TRACKER"] = "RASTREADOR";
  SystemCategoryCode2["BWS_ACCESSORY"] = "ACESSORIO";
  return SystemCategoryCode2;
})(SystemCategoryCode || {});
var ProductCategoryType = /* @__PURE__ */ ((ProductCategoryType2) => {
  ProductCategoryType2["SYSTEM"] = "system";
  ProductCategoryType2["CUSTOM"] = "custom";
  return ProductCategoryType2;
})(ProductCategoryType || {});

// src/constants/commercial/proposal-delivery.constants.ts
var BWS_PICKUP_LOCATIONS = [
  {
    id: "bws-barueri",
    name: "Barueri/SP",
    // Address evidenced by docs/contracts/sim-card-official-contract.txt.
    address: {
      street: "Cal\xE7ada das Ac\xE1cias",
      number: "31",
      district: "Centro Comercial Alphaville",
      city: "Barueri",
      state: "SP",
      zip_code: "06453-054"
    }
  },
  {
    id: "bws-belo-horizonte",
    name: "Belo Horizonte/MG",
    // Operational address supplied by the user on 06/10/2026.
    address: {
      street: "AV DEL REY",
      number: "111",
      district: "CAICARAS",
      city: "Belo Horizonte",
      state: "MG",
      zip_code: "30775-240",
      complement: "SALA 314 BLOCO A"
    }
  }
];
function isProposalDeliveryComplete(proposal) {
  if (!proposal) return false;
  return proposal.deliveryMode === "BWS" ? !!(proposal.pickupLocationId && proposal.pickupAddressSnapshot) : !!proposal.deliveryAddressId;
}
function proposalFiscalAddressId(proposal) {
  return proposal.deliveryMode === "BWS" ? proposal.fiscalAddressId ?? null : proposal.deliveryAddressId ?? null;
}
function proposalFreight(proposal) {
  return proposal.deliveryMode === "BWS" ? 0 : proposal.payment?.freteInCents ?? 0;
}

// src/constants/production/configuration-profile.constants.ts
var e3PlusFunctions = [
  {
    label: "Posi\xE7\xE3o de LBS",
    name: "lbs_position",
    data: [
      { label: "Ligado", value: true },
      { label: "Desligado", value: false }
    ]
  },
  {
    label: "Atualiza\xE7\xE3o da posi\xE7\xE3o em curva",
    name: "cornering_position_update",
    data: [
      { label: "Ligado", value: true },
      { label: "Desligado", value: false }
    ]
  },
  {
    label: "Alerta de igni\xE7\xE3o / Corte de alimenta\xE7\xE3o (SMS)",
    name: "ignition_alert_power_cut",
    data: [
      { label: "Ligado", value: true },
      { label: "Desligado", value: false }
    ]
  },
  {
    label: "Alerta de falha de GPRS (SMS)",
    name: "gprs_failure_alert",
    data: [
      { label: "Ligado", value: true },
      { label: "Desligado", value: false }
    ]
  },
  {
    label: "Funcionamento dos LEDS",
    name: "led",
    data: [
      { label: "Ligado", value: true },
      { label: "Desligado", value: false }
    ]
  },
  {
    label: "Igni\xE7\xE3o Virtual",
    name: "virtual_ignition",
    data: [
      { label: "Ligado", value: true },
      { label: "Desligado", value: false }
    ]
  }
];
var e3PlusOptionalFunctions = [
  {
    label: "Modo de Opera\xE7\xE3o",
    name: "operation_mode",
    data: [
      { label: "Ligado", value: true },
      { label: "Desligado", value: false }
    ]
  }
];
var e3Plus4GFunctions = [
  {
    label: "Detec\xE7\xE3o de jammer",
    name: "jammer_detection",
    data: [
      { label: "Ligado", value: true },
      { label: "Desligado", value: false }
    ]
  },
  {
    label: "Anti-Furto",
    name: "anti_theft",
    data: [
      { label: "Ligado", value: true },
      { label: "Desligado", value: false }
    ]
  },
  {
    label: "Posi\xE7\xE3o de LBS",
    name: "lbs_position",
    data: [
      { label: "Ligado", value: true },
      { label: "Desligado", value: false }
    ]
  },
  {
    label: "Funcionamento dos LEDS",
    name: "led",
    data: [
      { label: "Ligado", value: true },
      { label: "Desligado", value: false }
    ]
  }
];
var e3Plus4GOptionalFunctions = [
  {
    label: "Limpar Buffer",
    name: "clear_buffer",
    data: [
      { label: "Ligado", value: true },
      { label: "Desligado", value: false }
    ]
  },
  {
    label: "Resetar Hor\xEDmetro",
    name: "clear_horimeter",
    data: [
      { label: "Ligado", value: true },
      { label: "Desligado", value: false }
    ]
  }
];
var lockType = [
  { label: "Progressivo", value: 1 },
  { label: "Instant\xE2neo", value: 2 },
  { label: "Inverso", value: 3 }
];
var bws4GLockType = [
  { label: "Padr\xE3o", value: 30 },
  { label: "Inverso", value: 31 }
];
var lockTypeVariation = [
  { label: "Progressivo", value: 1 },
  { label: "Instant\xE2neo", value: 2 }
];
var accelerometerSensitivity = [
  { value: 0, label: 0 },
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 },
  { value: 7, label: 7 },
  { value: 8, label: 8 },
  { value: 9, label: 9 },
  { value: 10, label: 10 }
];
var economyMode = [
  { value: 0, label: "GPS Ligado (Em Sleep)" },
  { value: 1, label: "GPS Desligado (Em Sleep)" }
];
var e3Plus4GEconomyMode = [
  { value: 0, label: "Desligado" },
  { value: 1, label: "Meia Economia" },
  { value: 2, label: "Economia M\xE1xima" }
];
var nb2EconomyMode = [
  { value: 0, label: "Desligado" },
  { value: 1, label: "Meia Economia" },
  { value: 2, label: "Economia M\xE1xima" }
];
var workMode = [
  { value: "SLAVE", label: "Bot\xE3o de P\xE2nico" },
  { value: "MASTER", label: "Igni\xE7\xE3o F\xEDsica" },
  { value: "NEGATIVE", label: "Viola\xE7\xE3o de m\xF3dulo" }
];
var communicationType = [
  { value: "TCP", label: "TCP" },
  { value: "UDP", label: "UDP" }
];
var bws4GCommunicationType = [{ value: "TCP", label: "TCP" }];
var protocolType = [
  { value: "E3+", label: "E3" },
  { value: "GT06", label: "GT06" }
];
var bws4GProtocolType = [{ value: "E3+", label: "E3" }];
var jammerDetection = [
  { value: 0, label: "Desligado" },
  { value: 1, label: "Ligado" }
];
var input1 = [
  { value: 1, label: "Igni\xE7\xE3o" },
  { value: 2, label: "SOS" }
];
var input2 = [
  { value: 1, label: "Monitora" },
  { value: 2, label: "SOS" },
  { value: 3, label: "M\xF3dulo" }
];
var nb2LockType = [
  { value: 1, label: "Progressivo" },
  { value: 2, label: "Instant\xE2neo" },
  { value: 3, label: "Inverso" },
  { value: 30, label: "Padr\xE3o" },
  { value: 31, label: "Inverso (NB-2)" }
];
var configurationProfileConstants = {
  DM_E3_PLUS: {
    functions: e3PlusFunctions,
    optionalFunctions: e3PlusOptionalFunctions,
    lockType,
    accelerometerSensitivity,
    economyMode,
    workMode
  },
  DM_E3_PLUS_4G: {
    functions: e3Plus4GFunctions,
    optionalFunctions: e3Plus4GOptionalFunctions,
    lockType,
    accelerometerSensitivity,
    economyMode: e3Plus4GEconomyMode,
    communicationType,
    protocolType,
    jammerDetection,
    input1,
    input2
  },
  DM_BWS_4G: {
    functions: e3Plus4GFunctions,
    optionalFunctions: e3Plus4GOptionalFunctions,
    lockType: bws4GLockType,
    lockTypeVariation,
    accelerometerSensitivity,
    communicationType: bws4GCommunicationType,
    protocolType: bws4GProtocolType,
    jammerDetection,
    input1,
    input2
  },
  // Cópia do BWS 4G — vai divergir quando a parte LoRa for implementada
  DM_BWS_PLUS_4G_LORA: {
    functions: e3Plus4GFunctions,
    optionalFunctions: e3Plus4GOptionalFunctions,
    lockType: bws4GLockType,
    lockTypeVariation,
    accelerometerSensitivity,
    communicationType: bws4GCommunicationType,
    protocolType: bws4GProtocolType,
    jammerDetection,
    input1,
    input2
  },
  DM_BWS_NB2: {
    economyMode: nb2EconomyMode,
    lockType: nb2LockType
  }
};
export {
  ACCOUNT_TYPE_LABELS,
  ACCOUNT_TYPE_OPTIONS,
  AuditDomain,
  AuditType,
  BILLING_SITUATION_OPTIONS,
  BILLING_STATUS_OPTIONS,
  BRAZILIAN_UF_LIST,
  BRAZILIAN_UF_NAMES,
  BRAZILIAN_UF_VALUES,
  BWS_PICKUP_LOCATIONS,
  CLIENT_SECTOR_LABELS,
  ClientSectorEnum,
  ConfigurationProfileType,
  ContactDepartmentEnum,
  ContactRoleEnum,
  ControlCodes,
  Device,
  FinancialObligationMethod,
  FinancialObligationStatus,
  JobStatus,
  OmieBillingSlipIntegrationState,
  OmieEnterpriseEnum,
  PRICE_TABLE_STATUS_LABELS,
  PriceTableStatus,
  ProductCategoryType,
  ProposalStatus,
  SystemCategoryCode,
  TAX_REGIME_LABELS,
  TO_BILL_FOR_OPTIONS,
  TaxRegime,
  configurationProfileConstants,
  isProposalDeliveryComplete,
  proposalFiscalAddressId,
  proposalFreight
};
//# sourceMappingURL=index.js.map